import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {global} from "../../environments/global";

/**
 * Generated class for the ScrollListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'scroll-list',
  templateUrl: 'scroll-list.html'
})
export class ScrollListComponent implements OnInit, OnChanges {

  @Input('list') list: TemplateRef<any>;
  @Input('expOpt') expOpt: ExceptionOption = {};
  @Input('data') data: Array<any>;
  @Input('totalCount') totalCount: number;

  @Output() onErrConfirmed = new EventEmitter();
  @Output() onNodataConfirmed = new EventEmitter();
  @Output() onPageNext = new EventEmitter();

  ERROR_EXP: symbol = Symbol();
  NODATA_EXP: symbol = Symbol();

  curException: symbol;

  haveNextPage: boolean = false;

  //用来锁翻页
  dataPre;

  constructor() {
    console.log('Hello ScrollListComponent Component');
  }


  ngOnInit(): void {
    this.expOpt = this.expOpt || {};
      this.expOpt.nodataText = this.expOpt.nodataText || global.nodataText;
      this.expOpt.errText = this.expOpt.errText || global.errText;
      this.expOpt.errBtnText = this.expOpt.errBtnText || global.errBtnText;
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    this.updateView();
  }

  public showErr() {
    this.curException = this.ERROR_EXP;
  }

  public expConfirmClicked() {
    this.onErrConfirmed.emit();
    this.curException = undefined;
    this.data = undefined;
  }

  public nodataConfirmClicked() {
    this.onNodataConfirmed.emit();
  }

  private showNodata() {
    this.curException = this.NODATA_EXP;
  }

  private dismissNodata() {
    this.curException = undefined;
  }

  private updateView() {
    if (this.data) {
      if (this.data.length == 0) {
        this.showNodata();
      } else {
        this.dismissNodata();
        this.haveNextPage = (this.totalCount > this.data.length);
      }
    }
  }

  /**
   * 上拉加载更多*/
  public loadMore(e) {
    let el = e.target;
    if (
      el.scrollTop + el.clientHeight > el.scrollHeight - 1 && this.haveNextPage
    ) {
      //这里是为了在加载下一页之中不被触发
      if (this.data != this.dataPre) {
        this.dataPre = this.data;
        this.onPageNext.emit();
      }
    }
  }

}

export interface ExceptionOption {
  nodataText?: string,
  nodataBtnText?: string,
  errText?: string,
  errBtnText?: string,
}



// WEBPACK FOOTER //
// ./src/components/scroll-list/scroll-list.ts